import { client } from './setup';
import { AVAILABILITY_API } from '../globals';

export default {
    getAvailability: (id, start, end) => client.get(`${AVAILABILITY_API}/${id}/${start}/${end}`),
}